import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { DoctorBreadcrumbService } from "../../shared/breadcrumb.service";
import { MessageService, SelectItem } from "primeng/api";
import { ReferralDoctorsModel } from "../../../../models/Doctorreferral";
import { DoctorReferralService } from "../../../../services/doctor-referral.service";
import { DoctorsService } from "../../../../services/doctors.service";
import { ConfirmationService } from "primeng/api";
import {
    PromiseResult,
    ErrorModel,
    ServerError,
} from "../../../../models/PromiseResult";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { TraceClassDecorator } from "@sentry/angular";
import { TokenService } from "../../../../utilities/token.service";
import { ProviderStateService } from "src/app/services/provider-state.service";

interface DoctorsRolesData {
    sr_no: number;
    name: string;
    specialty_name: string;
    country_name: string;
    state_name: string;
    role: string;
    featured_doctor_id: number;
    doctor_user_guid: string;
    role_id: number;
}

@TraceClassDecorator()
@Component({
    selector: "app-registered",
    templateUrl: "./registered.component.html",
    styleUrls: ["../../../../../assets/css/custom-egd.css"],
    encapsulation: ViewEncapsulation.None,
    providers: [ConfirmationService],
})
export class RegisteredComponent implements OnInit {
    constructor(
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly doctorreferralService: DoctorReferralService,
        private readonly doctorService: DoctorsService,
        private readonly messageService: MessageService,
        private readonly router: Router,
        private readonly titleService: Title,
        private readonly tokenUtil: TokenService,
        private readonly providerstateService: ProviderStateService
    ) {

    }
    display: boolean = false;
    is_primary_provider: boolean = false;
    slug: string = "";
    showConfirmationDialog() {
        this.display = true;
    }
    close() {
        this.display = false;
    }
    DoctorsRoles: DoctorsRolesData[] = [];
    ApprovedDoctors: ReferralDoctorsModel[] = [];
    ErrorMessage: string = null;
    Roles: SelectItem[] = [];
    SelectedRole;
    DoctorProfileVar: boolean = false;
    selected_doctor_featured;
    readonly displayedColumns: string[] = [
        "created_at",
        "request_sent_date",
        "doctor_referred_name",
        "specialty_name",
        "name",
        "country_name",
        "state_name",
        "Doctoremail",
        "contact",
        "request_approved_date",
        "approved_by_name",
    ];

    readonly displayedColumnsTwo: string[] = [
        "sr_no",
        "name",
        "specialty_name",
        "country_name",
        "state_name",
        "role",
        "featured_doctor_id",
    ];


    edit_id: number;
    featured_option: SelectItem[] = [];
    login_role: number = -1;
    private current_user_guid: string = null;
    selected_current_roleid_user_guid: string = null;
    selected_user_guid: string = null;
    loading: boolean;
    loading1: boolean;

    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;

    table_response: PromiseResult;
    table_error: ErrorModel;
    table_serverError: ServerError;
    table_posting: boolean;

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null,
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null,
        };
    }

    private async ResetResultTableModels(): Promise<void> {
        this.table_response = {
            success: null,
            error: null,
            data: null,
        };
        this.table_serverError = {
            statusCode: null,
            error: null,
            message: null,
        };
    }

    async ngOnInit() {
        this.titleService.setTitle("Dashboard - Registered");
        this.slug = this.providerstateService.getProviderSlug();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        this.breadcrumbService.setItems([
            { label: "Dashboard", routerLink: [`/${this.slug}/doctor`] },
            { label: "Doctor Registration" },
            { label: "Registered" },
        ]);
        await this.ResetResultModels();
        await this.ResetResultTableModels();
        this.login_role = this.tokenUtil.findRoleId();
        this.current_user_guid = sessionStorage.getItem("userid");
        await this.CancelRoleChange();
        await this.GetAllRoles();
        await this.GetApprovedDoctors();
        await this.GetDoctorswithRoles();
        this.featured_option = [
            {
                label: "Featured",
                value: true,
            },
            {
                label: "Not Featured",
                value: false,
            },
        ];
    }

    async CancelRoleChange() {
        this.edit_id = -1;
        this.SelectedRole = {
            label: null,
            value: null,
        };
        this.selected_doctor_featured = {
            label: null,
            value: null,
        };
        this.display = false;
        this.loading = false;
        this.loading1 = false;
        this.selected_user_guid = null;
    }

    async EnableRoleChange(doctorsRolesData: DoctorsRolesData) {
        // this.selected_current_roleid_user_guid=user_guid;

        //   for(let i=0;i<this.DoctorsRoles.length;i++){
        //         if(this.DoctorsRoles[i].doctor_user_guid==doctorsRolesData.doctor_user_guid){
        //             this.edit_id = i+1;
        //             break;
        //         }
        //     }
        this.selected_user_guid = doctorsRolesData.doctor_user_guid;
        this.SelectedRole.value = doctorsRolesData.role_id;
        this.SelectedRole.label = doctorsRolesData.role;
        this.selected_doctor_featured.value =
            doctorsRolesData.featured_doctor_id;
        this.selected_doctor_featured.label =
            doctorsRolesData.featured_doctor_id ? "Featured" : "Not Featured";
        if (
            this.SelectedRole.value == 1 ||
            this.SelectedRole.value == 4 ||
            this.SelectedRole.value == 5
        ) {
            this.Roles = [
                {
                    label: "Doctor",
                    value: 1,
                },
                // {
                //   "label": "Admin",
                //   "value": 2
                // },
                // {
                //   "label": "SuperAdmin",
                //   "value": 3
                // },
                {
                    label: "SuperAdmin_Doctor",
                    value: 4,
                },
                {
                    label: "Admin_Doctor",
                    value: 5,
                },
            ];

            this.featured_option = [
                {
                    label: "Featured",
                    value: true,
                },
                {
                    label: "Not Featured",
                    value: false,
                },
            ];
        } else if (
            this.SelectedRole.value == 2 ||
            this.SelectedRole.value == 3
        ) {
            this.Roles = [
                // {
                //   "label": "Doctor",
                //   "value": 1
                // },
                {
                    label: "Admin",
                    value: 2,
                },
                {
                    label: "SuperAdmin",
                    value: 3,
                },
                // {
                //   "label": "SuperAdmin_Doctor",
                //   "value": 4
                // },
                // {
                //   "label": "Admin_Doctor",
                //   "value": 5
                // }
            ];

            this.featured_option = [
                // {
                //     label: "Featured",
                //     value: true,
                // },
                {
                    label: "Not Featured",
                    value: false,
                },
            ];

            this.selected_doctor_featured.value = false;
            this.selected_doctor_featured.label = "Not Featured";
        }
    }

    async ChangeRoles() {
        await this.ResetResultModels();
        this.posting = true;

        await this.doctorService
            .UpdateRolesandfeatured(
                this.selected_user_guid,
                this.SelectedRole.value,
                this.selected_doctor_featured.value
            )
            .toPromise()
            .then((result) => {
                this.response = result;
                if (this.response.success) {
                    for (const doc of this.DoctorsRoles) {
                        if (doc.doctor_user_guid == this.selected_user_guid) {
                            doc.role = this.SelectedRole.label;
                            doc.role_id = this.SelectedRole.value;
                            doc.featured_doctor_id =
                                this.selected_doctor_featured.value;
                        }
                    }
                    this.selected_user_guid = null;

                    this.edit_id = -1;
                    this.SelectedRole = {
                        value: null,
                        label: null,
                    };
                    this.selected_doctor_featured = {
                        label: null,
                        value: null,
                    };
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Role changed successfully",
                    });
                } else if (!this.response.success) {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        sticky: true,
                        detail:
                            result.error.code + " : " + result.error.message,
                    });
                }
                this.display = false;
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.display = false;
                this.posting = false;
            });
        await this.GetDoctorswithRoles();
    }

    async GetApprovedDoctors() {
        await this.ResetResultTableModels();
        this.loading = true;
        await this.doctorreferralService
            .getApprovedDoctorReferrals()
            .toPromise()
            .then((result) => {
                this.table_response = result;
                if (this.table_response.success) {
                    // this.ApprovedDoctors=result.data;
                    let temp = [];
                    for (let i = 0; i < result.data.length; i++) {
                        let transaction_obj = {
                            created_at: result.data[i].created_at,
                            request_sent_date: result.data[i].request_sent_date,
                            doctor_referred_name: !result.data[i]
                                .doctor_referred_name
                                ? "Self"
                                : result.data[i].doctor_referred_name,
                            name: result.data[i].name,
                            specialty_name:
                                result.data[i].d_specialty_type?.specialty_name,
                            country_name: result.data[i].country?.country_name,
                            state_name: result.data[i].state_name,
                            Doctoremail: result.data[i].d_email,
                            contact: result.data[i].contact,
                            request_approved_date:
                                result.data[i].request_approved_date,
                            approved_by_name: result.data[i].approved_by_name,
                        };
                        temp.push(transaction_obj);
                    }
                    this.ApprovedDoctors = temp;
                    this.ErrorMessage = null;
                    this.table_error = null;
                } else if (!this.table_response.success) {
                    this.table_error = result.error;
                    this.ApprovedDoctors = [];
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.table_serverError = error.error;
                this.table_response.success = false;
                this.loading = false;
            });
        this.loading = false;
    }

    async GetAllRoles() {
        await this.ResetResultModels();
        this.loading1 = true;
        await this.doctorService
            .GetAllRoles()
            .toPromise()
            .then((result) => {
                if (result.success) {
                    // this.Roles = result.data;
                    let temp: any[] = [];
                    for (let i = 0; i < result.data.length; i++) {
                        temp.push({
                            label: result.data[i].title.toString(),
                            value: result.data[i].id,
                        });
                    }
                    this.Roles = temp;
                }
            });
    }

    async GetDoctorswithRoles() {
        await this.ResetResultTableModels();
        this.loading1 = true;
        await this.doctorService
            .GetDoctorlist()
            .toPromise()
            .then((result) => {
                this.table_response = result;
                if (this.table_response.success) {
                    let temp: DoctorsRolesData[] = [];

                    for (let i = 0; i < result.data.length; i++) {
                        // let obj={
                        //     sr_no:i+1,
                        //     doctor:result.data[i]
                        // }
                        // this.DoctorsRoles.push(obj);

                        let transaction_obj: DoctorsRolesData = {
                            sr_no: i + 1,
                            name:
                                result.data[i].first_name +
                                " " +
                                (result.data[i].middle_name == null ? '' : result.data[i].middle_name) +
                                " " +
                                result.data[i].last_name,
                            specialty_name:
                                result.data[i].d_specialty_type
                                    .specialty_name,
                            country_name: result.data[i].country.country_name,
                            state_name: result.data[i].state_name,
                            role: result.data[i].role_type.title,
                            featured_doctor_id:
                                result.data[i].featured_doctor_id,
                            doctor_user_guid: result.data[i].user_guid,
                            role_id: result.data[i].role_type.id,
                        };
                        temp.push(transaction_obj);
                    }
                    this.DoctorsRoles = temp;
                    this.ErrorMessage = null;
                } else if (!this.table_response.success) {
                    this.ErrorMessage = result.error.message;
                    this.DoctorsRoles = [];
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.table_serverError = error.error;
                this.table_response.success = false;
                this.loading1 = false;
            });
        this.loading1 = false;
    }

    user_guid: string = null;
    async DoctorProfileDialog(close: boolean, user_guid: string) {
        this.DoctorProfileVar = close;
        this.user_guid = user_guid;
    }

    gotoEditProfile(current_user_guid: string): void {
        const route = current_user_guid;

        this.router.navigate(["/" + this.slug + "/doctor/dprofileedit/" + route]);
    }
}
